export default __webpack_public_path__ + "static/marco-tanzola-35a9d24e4d07777f969354e53abaa357.jpg";